import I18n from 'I18n';
import { Small } from 'foundations-components/transitional/components/Small';
import { toObjectSegFilterStrict } from 'customer-data-filters/converters/objectSeg/toObjectSegFilter';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
// @ts-expect-error untyped import
import { Known } from 'customer-data-filters/filterQueryFormat/operator/Operators';
import { ExpressionFieldFilterLabel } from './ExpressionFieldFilterLabel';
import { ExpressionFieldFilterPanel } from './ExpressionFieldFilterPanel';
// @ts-expect-error untyped import
import { useFilterEdit } from '../FilterEditContext';
import { Filter } from '../../../../schema/filter-records';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import SnowflakeFilterEditPopover from '../SnowflakeFilterEditPopover';
// @ts-expect-error untyped import
import SnowflakeFilterTile from '../SnowflakeFilterTile';
// @ts-expect-error untyped import
import SnowflakeFilterWrapper from '../SnowflakeFilterWrapper';
// @ts-expect-error untyped import
import { useExpressionField } from '../SourceMeta';
import { useGetExpressionFilterErrorTooltipMessage } from './use-get-expression-filter-error-tooltip-message';
import { buildFieldFromExpressionField } from '../../../../utils/expression-field-utils';
// @ts-expect-error untyped import
import { SNOWFLAKE_FILTER_FAMILY } from '../../xo-filter-utils';
import { NewExpressionFieldFilterPanel } from './NewExpressionFieldFilterPanel';
import { getIsUngatedToSnowflakePropertyFilterMigration } from '../../../../utils/filter-utils';
import { ExpressionFieldFilterDisplayLabel } from './ExpressionFieldFilterDisplayLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StagedExpressionFieldFilterTile = ({
  filterRef,
  index
}) => {
  const fieldName = filterRef.field;
  const expressionField = useExpressionField(fieldName);
  const field = buildFieldFromExpressionField(expressionField);
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const filter = Filter({
    field,
    filter: {
      filterType: 'PROPERTY',
      property: field.name,
      operation: undefined
    }
  });
  const [{
    editingStagedFilterIndex
  }, editCallbacks] = useFilterEdit();
  const propertyType = field.type;
  const handleRemove = () => {
    editCallbacks.handleRemoveStagedFilter(index);
  };
  const editableFilter = Filter({
    field,
    filter: toObjectSegFilterStrict(Known.of(DSFieldRecord({
      name: fieldName,
      type: propertyType
    })), SNOWFLAKE_FILTER_FAMILY, gate => getIsUngated(gate, userGates), true)
  });
  const showEditPanel = index === editingStagedFilterIndex;
  const handleEdit = () => {
    editCallbacks.handleStagedFilterEdit(index);
  };
  const isUngatedToPropertyFilterMigration = getIsUngatedToSnowflakePropertyFilterMigration(userGates);
  const FilterPanel = isUngatedToPropertyFilterMigration ? NewExpressionFieldFilterPanel : ExpressionFieldFilterPanel;
  const editPanel = /*#__PURE__*/_jsx(FilterPanel, {
    filter: editableFilter,
    groupId: undefined,
    onDone: ({
      draftFilter,
      draftGroupId
    }) => editCallbacks.handleStagedFilterChange(draftFilter, draftGroupId),
    onCancel: editCallbacks.handleCancelEdit
  });
  const errorTooltipMessage = useGetExpressionFilterErrorTooltipMessage(filter);
  const LabelItem = isUngatedToPropertyFilterMigration ? ExpressionFieldFilterDisplayLabel : ExpressionFieldFilterLabel;
  return /*#__PURE__*/_jsx(SnowflakeFilterTile, {
    children: /*#__PURE__*/_jsx(SnowflakeFilterEditPopover, {
      editPanel: editPanel,
      open: showEditPanel,
      onClose: editCallbacks.handleCancelEdit,
      children: /*#__PURE__*/_jsxs(SnowflakeFilterWrapper, {
        highlighted: showEditPanel,
        onEdit: handleEdit,
        onRemove: handleRemove,
        children: [/*#__PURE__*/_jsx(LabelItem, {
          errorTooltipMessage: errorTooltipMessage,
          filter: filter
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: I18n.text('reporting-snowflake.filter-editor.click-to-apply')
        })]
      })
    })
  });
};